import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  GasExtinguishingSystemDesign,
  GasSystemArea
} from '@authority-labs/api-interfaces';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'authority-labs-gas-extinguishing-system',
  templateUrl: './gas-extinguishing-system.component.html',
  styleUrls: ['./gas-extinguishing-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GasExtinguishingSystemComponent {
  @Input() data: GasExtinguishingSystemDesign;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  selectedTab = 0;

  onDataChange(): void {
    this.dataChange.emit();
  }

  tabName(index: number) {
    return `מערכת ${index + 1}`;
  }

  addTest(): void {
    this.data.areas.push(new GasSystemArea());
    this.selectedTab = this.data.areas.length - 1;
    this.onDataChange();
  }

  duplicateTest(): void {
    const data = cloneDeep(this.data.areas[this.selectedTab]);
    this.data.areas.push(new GasSystemArea(data));
    this.selectedTab = this.data.areas.length - 1;
    this.onDataChange();
  }

  removeTest(): void {
    this.data.areas.splice(this.selectedTab, 1);
    this.onDataChange();
  }
}
